module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-21.c8ef06d.woff2";